import React from 'react'
import { Row, Col, Divider, Tag } from 'antd';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux'
import Category from '../../components/Category'
import _ from 'lodash'
import API from '@/api'
import './index.less'

@connect(
  state => ({
    categories: state.categories
  })
)
class ArticleDetail extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      contentMinHeight: 0,
      title: '',
      intro: '',
      content: '',
      categories: []
    }
  }

  async componentDidMount () {
    const { articleId } = this.props.match.params

    const res = await API.GetArticle({ article_id: articleId })
    if (res.code !== 200) return

    this.setState({
      title: res.result.title,
      intro: res.result.intro,
      content: res.result.content,
      categories: res.result.categories,
    })
  }

  render () {
    const { title, intro, content } = this.state
    const { categories } = this.props

    return (
      <Row gutter={18}>
        <Col span={18}>
          <div className="article-container">
            <div className="article-wrapper">
              <div className="article-title">
                {title}
              </div>
              <Divider />
              {this.state.categories && this.state.categories.map(id => {
                const category = _.find(categories, { id }) || {}
                return (
                  <Tag color="gold" key={id}>
                    {category.title}
                  </Tag>
                );
              })}
              {
                intro && <div className="article-intro">
                  {intro}
                </div>
              }
              <Divider />
              <div className="article-detail">
                <div dangerouslySetInnerHTML={{__html: content}}></div>
              </div>
            </div>
          </div>
        </Col>
        <Col span={6}>
          <Category />
        </Col>
      </Row>
    )
  }
}

export default withRouter(ArticleDetail)
